var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap gap-2"},[(_vm.question.profession)?_c('JoszakiPill',{attrs:{"to":_vm.localePath({
        name: 'professionQuestions',
        params: { profession: _vm.question.profession.seoName },
      }),"component":"NuxtLink"},on:{"click":function($event){return _vm.$trackers.trackClick('CardQuestionProfession')}}},[_vm._v(" "+_vm._s(_vm.question.profession.name)+" ")]):_vm._e(),(_vm.question.professionTask)?_c('JoszakiPill',{attrs:{"inverted":true,"to":_vm.localePath({
        name: 'professionTaskQuestions',
        params: { professionTask: _vm.question.professionTask.seoName },
      }),"component":"NuxtLink"},on:{"click":function($event){return _vm.$trackers.trackClick('CardQuestionProfessionTask')}}},[_vm._v(" "+_vm._s(_vm.question.professionTask.name)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }